import * as React from 'react';
import { Select as AntdSelect } from 'antd';
import { SelectProps as AntdSelectProps } from 'antd/lib/select';
import classnames from 'classnames/bind';
import Icon from '../../Icon';
import { AppContext } from '@/utils/appProvider';
import S from './index.less';

const $c = classnames.bind(S);

const { Option } = AntdSelect;

export interface SelectOption {
  label: string;
  value: string;
  disabled?: boolean;
}
export interface SelectProps extends AntdSelectProps<any> {
  options?: SelectOption[];
  defaultValue?: string;
}

const Select: React.FC<SelectProps> = (props) => {
  const { children, className, options, defaultValue, dropdownClassName, ...rest } = props;
  const { prefixCls } = React.useContext(AppContext);

  return (
    <AntdSelect
      className={classnames($c(`select`), className)}
      suffixIcon={<Icon name="icon-jiantou" />}
      dropdownClassName={classnames($c(`select-dropdown`), dropdownClassName)}
      defaultValue={defaultValue}
      notFoundContent={<span className={$c(`select-dropdown-empty`)}>暂无数据</span>}
      {...rest}
    >
      {options
        ? options.map((item) => {
            return (
              <Option key={item.value} disabled={item.disabled} value={item.value} title="">
                {item.label}
              </Option>
            );
          })
        : children}
    </AntdSelect>
  );
};

export default Select;
